export type DotProps = Readonly<{
  cx: number | undefined;
  cy: number;
}>;

export const Dot = ({ cx, cy }: DotProps) => <circle className="Dot" cx={cx} cy={cy} r={6} />;
